import { Box, Stack } from "@mui/system";
import BLDWebsitePerformanceCard from "./BLDWebsitePerformanceCard";

const BLDWebsitePerformance = () => {
  return (
    <>
      <Box>
        <Stack spacing={2}>
          <BLDWebsitePerformanceCard
            date="13/12/2025"
            cac="$497"
            cpaPV="$285"
            qftd="$316"
            ClickIn="$35"
            roiPercentage="-27%"
            roiColor="warning"
            rs="18%"
          />
          <BLDWebsitePerformanceCard 
            date="13/12/2025"
            cac="$336"
            cpaPV="$285"
            qftd="$316"
            ClickIn="$60"
            roiPercentage="26%"
            roiColor="warning"
            rs="30%"
          />
          <BLDWebsitePerformanceCard
            date="13/12/2025"
            cac="$299"
            cpaPV="$285"
            qftd="$316"
            ClickIn="$60"
            roiPercentage="25%"
            roiColor="warning"
            rs="25%"
          />
        </Stack>
      </Box>
    </>
  );
};

export default BLDWebsitePerformance;
